module.exports = __webpack_public_path__ + "img/39.e23a4132.jpg";